import type { ITable } from '../../types/table';

import styles from './table.module.scss';

/**
 * The scroll container and grid for a table.
 *
 * The inner element carries `role="table"`, so it is the direct parent of the
 * rows: assistive technology reads the same structure a native `<table>` would
 * give, even though this is built from `div`s for layout control.
 */
export const Table = ({
  children,
  maxHeight,
  tableId,
  ariaLabel,
  isLoading,
}: ITable) => {
  return (
    <div
      className={styles['table']}
      data-table-id={tableId || undefined}
      style={maxHeight ? { maxHeight, overflowY: 'auto' } : {}}
    >
      <div
        className={styles['table__content']}
        role="table"
        aria-label={ariaLabel || undefined}
        aria-busy={isLoading || undefined}
      >
        {children}
      </div>
    </div>
  );
};
